import { Component,Input } from '@angular/core';

import { WarnTypes } from '../../enum/warn-types';

@Component({
  selector: 'warn-icon',
  templateUrl: './warn-icon.component.html',
  styleUrls: ['./warn-icon.component.css']
})

export class WarnIconComponent {

  @Input()
  type: number;

  iconMapping = [
    {
      type: WarnTypes.PaymentExemption,
      icon: 'fas fa-calendar-times',
      title: 'Es liegt eine ablaufende Zuzahlungsbefreiung vor.'
    }, 
    {
      type: WarnTypes.DueReminders,
      icon: 'fas fa-bell',
      title: 'Es gibt Wiedervorlagen für den heutigen Tag.'
    },
    {
      type: WarnTypes.ExpiringOrders,
      icon: 'fas fa-exclamation',
      title: 'Es liegt mindestens eine ablaufende Kostenübernahme vor.'
    }
  ];

  get title() {
    return this.getIconConfig().title
  }

  get class() {
    return this.getIconConfig().icon;
  }


  constructor() {}

  private getIconConfig() {
    if (this.type) {
      return this.iconMapping.find((value) => {
        return (value.type === this.type);
      });
    }

    return {
      type: 0,
      icon: 'fas fa-times',
      title: 'Unbekannt'
    }
  }

}
